/*
 * The english translation of: SecondaryWritingTasksBox
 */
export const SECONDARY_WRITING_TASKS_BOX_EN = {
  grundfunktionenTitle: 'Essential-Tasks',
  dyn: {
    WRITING_TASK: {
      shorten: 'Shorten Text',
      correcten: 'Correct Spelling',
      qualitylang: 'Correct Language Style',
      analyse: 'Analyse Text',
      easylang: 'Simplifiy Text',
      formalize: 'Professional Tone',
      summarize: 'Summarize',
      bulletpoints: 'Bullet Points',
      translate: 'Translate',
      socialmedia: 'Social Media'
    }
  },
  noContentToProcess: 'No content to process',
  applyingTask: 'Generating...',
  taskCompleted: 'Generation completed successfully',
  taskCanceled: 'Generation canceled',
  taskFailed: 'Failed to apply generation: {error}',
  customAction: 'Custom Action',
  execute: 'Execute',
  customActionHint: 'Max 20 characters - Beta function for selected users only',
  applyingCustomTask: 'Generating...',
  customTaskCompleted: 'Generation completed successfully',
  customTaskCanceled: 'Generation canceled',
  customTaskFailed: 'Failed to apply generation: {error}'
}

/*
 * The german translation of: SecondaryWritingTasksBox
 */
export const SECONDARY_WRITING_TASKS_BOX_DE = {
  grundfunktionenTitle: 'Essential-Tasks',
  dyn: {
    WRITING_TASK: {
      shorten: 'Kürzen',
      correcten: 'Rechtschreibung korrigieren',
      qualitylang: 'Sprachstil korrigieren',
      analyse: 'Text analysieren',
      easylang: 'Text vereinfachen',
      formalize: 'Förmliche Sprache',
      summarize: 'Zusammenfassen',
      bulletpoints: 'Stichpunkte',
      translate: 'Übersetzen',
      socialmedia: 'Social Media'
    }
  },
  noContentToProcess: 'Kein Inhalt zu verarbeiten',
  applyingTask: 'Generieren...',
  taskCompleted: 'Generierung erfolgreich abgeschlossen',
  taskCanceled: 'Generierung abgebrochen',
  taskFailed: 'Fehler beim Anwenden der Generierung: {error}',
  customAction: 'Benutzerdefinierte Aktion',
  execute: 'Ausführen',
  customActionHint: 'Max 20 Zeichen - Beta-Funktion nur für ausgewählte Benutzer',
  applyingCustomTask: 'Generierung wird angewendet...',
  customTaskCompleted: 'Generierung erfolgreich abgeschlossen',
  customTaskCanceled: 'Generierung abgebrochen',
  customTaskFailed: 'Fehler beim Anwenden der Generierung: {error}'
}
